export interface TableList {
    id: string;
    name: string;
    tableName: string;
    displayName: string;
    enabled: boolean;
    displayObjectType: string;
    objectType: number;
}

export interface DbTemplateInfo {
    dbTemplate: DbTemplate;
    dbTemplateItems: DbTemplateItem[];
}


export interface DbTemplate {
    id: string;
    name: string;
    displayName: string;
    changed: string;
    enabled: boolean;
    dbObjectName: string;
    dbObjectType: number;
    dbTemplateGroupId: string;
    dbObjectSchemaName: string;
    allowRead: boolean;
    allowWrite: boolean;
    allowDelete: boolean;
    allowReadAll: boolean;
    allowSynchronousCall: boolean;
    isEos: boolean;
    enableRecordReadLimit: boolean;
    recordReadLimit: number;
    preProcessingOnRead: boolean;
    preProcessingOnWrite: boolean;
    preProcessingOnDelete: boolean;
    postProcessingOnRead: boolean;
    postProcessingOnWrite: boolean;
    postProcessingOnDelete: boolean;
    departmentAllowCreate: boolean;
    departmentAllowEdit: boolean;
    departmentAllowDelete: boolean;
}

export interface DbTemplateItem {
    id: string;
    dbTemplateId: string;
    dbColumnName: string;
    dbDataType: string;
    dbMaxLength: number | null;
    dbDefaultValue: string | null;
    dbIsNullable: boolean;
    name: string;
    defaultValue: string | null;
    defaultValueType: string; 
    defaultValueTypeNonSql: string;
    allowCreate: boolean;
    allowRead: boolean;
    allowUpdate: boolean;
    mandatory: boolean;
    isKey: boolean;
    changed: string;
    origin: number;

    // Helpers for UI (DB)
    originName: string;
    defaultValueItems: string[];
    isSystemField: boolean;
    errorMessage: string;    
}

export interface DbTemplateFilter {
    id: string;
    dbTemplateId: string;
    dbTemplateItemId: string;
    section: string;
    fieldOperator: string;
    fieldValue: string;
    placement: number;
    statementOperator: string;
}


export interface TemplateUsedIn {
    departmentId: string;
    departmentName: string;
    templateId: string;
    templateName: string;
    templateEnabled: boolean;
}

export interface DbTemplateGroup {
    id: string;
    name: string;
    schema: string;
    type: string;
}

export enum DbObjectTypeEnum {
    Table = 0,
    View = 1,
    StoredProcedure = 2
}

export enum DbObjectItemCreatedByEnum {
    NotSet = 0,
    Table = 1,
    View = 2,
    StoredProcedure = 3,
    SPInput = 4,
    SPOutput = 5,
    SPHybrid = 6
}
// "Tjek databasetabel" — forskelle mellem databaseskabelonen og databaseobjektet.
export enum SchemaChangeType {
    Added = 0,
    Removed = 1,
    Modified = 2
}

export enum SchemaChangeAction {
    Ignore = 0,
    Apply = 1,
    AddHidden = 2,
    RenameTo = 3
}

export interface DbTemplateSchemaColumn {
    dataType: string;
    maxLength: number | null;
    isNullable: boolean;
    defaultValue: string | null;
}

export interface DbTemplateSchemaChange {
    changeType: SchemaChangeType;
    dbTemplateItemId: string | null;
    columnName: string;
    fieldName: string;
    origin: DbObjectItemCreatedByEnum;
    template: DbTemplateSchemaColumn | null;
    database: DbTemplateSchemaColumn | null;
    mandatory: boolean;
    usedInTemplates: number;
    usedInFilters: number;
}

export interface DbTemplateSchemaDiff {
    objectExists: boolean;
    objectName: string;
    schemaName: string;
    objectType: DbObjectTypeEnum;
    outputColumnsKnown: boolean;
    changes: DbTemplateSchemaChange[];
}

export interface DbTemplateSchemaDecision {
    changeType: SchemaChangeType;
    dbTemplateItemId: string | null;
    columnName: string;
    origin: DbObjectItemCreatedByEnum;
    action: SchemaChangeAction;
    renameToColumnName: string | null;
    makeMandatory: boolean;
}

export interface ApplyDbTemplateSchemaDiffResult {
    added: number;
    removed: number;
    modified: number;
    renamed: number;
}

// Manuelt oprettet resultatkolonne (SPHybrid) på en stored procedure-skabelon.
export interface CreateDbTemplateField {
    columnName: string;
    name: string;
    dataType: string;
    maxLength: number | null;
    isNullable: boolean;
    dbDefaultValue: string | null;
}

// Skal svare til CreateDbTemplateFieldHandler.DataTypes — de typer synkroniseringen kan konvertere.
export const DB_FIELD_DATA_TYPES = [
    'bigint', 'binary', 'bit', 'char', 'date', 'datetime', 'datetime2', 'decimal', 'float', 'int', 'money', 'nchar',
    'numeric', 'nvarchar', 'real', 'smalldatetime', 'smallint', 'smallmoney', 'time', 'tinyint', 'uniqueidentifier',
    'varbinary', 'varchar'
];

export const DB_FIELD_DATA_TYPES_WITH_LENGTH = ['binary', 'char', 'nchar', 'nvarchar', 'varbinary', 'varchar'];
